import React from "react";
import { Helmet } from "react-helmet";
import { useLocation, useParams, useMatch } from "react-router";
import { useQuery, gql } from "@apollo/client";
import { HandleQuery, SeoData, EntryData } from "../queries";

export default function SEO({ title, description, image, article, })
{
    const { pathname } = useLocation();
    const { slug } = useParams();

    const query_state = useQuery(EntryData(slug ?? ""), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 
  
    const defaultTitle = data.entries[0]?.metaTitle ?? data.entries[0]?.displayTitle ?? data.entries[0]?.title ?? "Genesis Analytics";
    const defaultImage = data.entries[0]?.metaImage[0]?.url ?? data.entries[0]?.featureImage[0]?.url ?? data.site[1]?.siteImage[0]?.url;
    const defaultDescription = data.entries[0]?.metaDescription ?? data.entries[0]?.summary ?? data.site[1]?.siteDesciption;
    const siteUrl = "https://cms.genesis-analytics.com"; 
    const titleTemplate = "%s · Genesis Analytics";
    const twitterUsername = data.site[4]?.twitterHandle;

    // We can get more clever with aspect ratios for different platforms later
    const finalResizedImage = image ? (siteUrl + image) : (siteUrl + defaultImage);
    const seo = 
    {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: finalResizedImage,
        url: `https://www.genesis-analytics.com${pathname}`,
    }

    return (
        <Helmet title={seo.title} titleTemplate={titleTemplate}>
            <meta name="description" content={seo.description}/>
            <meta property="og:url" content={seo.url}/>
            <meta property="og:type" content={article ? "article" : "website"}/>
            <meta property="og:title" content={seo.title}/>
            <meta property="og:description" content={seo.description}/>
            <meta property="og:image" content={seo.image}/>
            <meta name="twitter:card" content="summary_large_image"/>
            <meta property="twitter:domain" content="genesis-analytics.com"/>
            <meta property="twitter:url" content={seo.url}/>
            <meta name="twitter:title" content={seo.title}/>
            <meta name="twitter:description" content={seo.description}/>
            <meta name="twitter:image" content={seo.image}/>
        </Helmet>
    );
}
